import React, {useEffect, useState} from "react";
import {useStyles} from "../styles/OddListeningStepStyle";
import {Box, Button, IconButton, Tab, Tabs, TextField, Typography} from "@material-ui/core";
import PropTypes from 'prop-types';
import clsx from "clsx";
import NoImage from '../../../../../common/images/NoImage.jpg';
import {ReactComponent as RefreshIcon} from '../../../../../common/images/RefreshIcon.svg';
import {ReactComponent as RefreshDisableIcon} from '../../../../../common/images/RefreshDisableIcon.svg';
import {inject, observer} from "mobx-react";
import {withRouter} from "react-router-dom";
import AfterDividedState from "./AfterDividedState";
import BeforeDividedState from "./BeforeDividedState";
import DividedTextBox from "./DividedTextBox";

function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <div>{children}</div>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function OddStepOne(props) {
    const classes = useStyles();
    const {contentStore,oddStepOneStore} = props;
    const isProcessing = oddStepOneStore.isProcessing;
    const {stepValue, dayValue} = props.contentStore;
    const [value, setValue] = useState(0);
    const fileInput = React.createRef();

    const handleChange = (event, newValue) => {
        setValue(newValue);
        oddStepOneStore.setContentTapIndex(newValue);
    };

    useEffect(() => {
        oddStepOneStore.getOddStepOneContent(stepValue,dayValue, processOddStepOneContent)
        props.contentStore.setOnSave(onSave);
        return ()=> {
            props.contentStore.setOnSave(null);
            props.oddStepOneStore.init();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onSave = () => {
        props.oddStepOneStore.modifyOddStepOneContent(stepValue, dayValue, () => {
            props.oddStepOneStore.getOddStepOneContent(stepValue,dayValue,processOddStepOneContent);
            props.contentStore.setReadyToSaveStep(false);
        })
    }

    const processOddStepOneContent = (res) => {
        const isCompleted = oddStepOneStore.isOddStepOneCompleted(res);
        contentStore.setReadyToMoveExit(isCompleted);
    }

    const onChangeImgText = (e) => {
        oddStepOneStore.setImageText(e.target.value);
    }

    const onClickCreateImgButton = () => {
        contentStore.getGeneratedImage(oddStepOneStore.getImageText(), (result) => oddStepOneStore.setImage(result));
    }

    const onClickUploadButton = (e) => {
        fileInput.current.click();
    };

    const onChangeUploadButton = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = async () => {
                const fileName = file.name;
                const extension = fileName.split('.').pop();
                const image = reader.result.split(',')[1];
                oddStepOneStore.uploadImage(fileName, extension, image);
            };
            reader.readAsDataURL(e.target.files[0]);
            oddStepOneStore.setImageText('');
            contentStore.setReadyToSaveStep(true);
        }
    };

    return (
        <Box className={classes.root}>
            <Box display={"flex"} justifyContent={"flex-first"}>
                <Box className={classes.boxWrap}>
                    <Box>
                        <Box position="static" className={classes.tabBox}>
                            <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                                <Tab label="한국어" {...a11yProps(0)} disableRipple/>
                                <Tab label="영어" {...a11yProps(1)} disableRipple/>
                                <Tab label="일본어" {...a11yProps(2)} disableRipple/>
                                <Tab label="중국어" {...a11yProps(3)} disableRipple/>
                            </Tabs>
                        </Box>

                        {Array.from({length: 4}, (_, i) => {
                            if (oddStepOneStore.contentList) {
                                return(
                                    <TabPanel key={i} value={value} index={i} className={classes.textBox}>
                                        { isProcessing ? (
                                            <AfterDividedState />
                                        ) : (
                                            <BeforeDividedState />
                                        )}
                                        <DividedTextBox />
                                    </TabPanel>
                                )
                            } else {
                                return null;
                            }})}

                    </Box>
                </Box>
                <Box className={classes.rightBoxWrap}>
                    <Box>
                        <Typography className={classes.imageTitle}>이미지 생성</Typography>
                        <Box className={classes.rightTextBox}>
                            <TextField
                                id="outlined-multiline-static"
                                multiline
                                minrows={4}
                                placeholder="이미지 생성을 위한 설명을 입력해 주세요."
                                variant="outlined"
                                value={oddStepOneStore.getImageText() !== null ? oddStepOneStore.getImageText() : ''}
                                onChange={onChangeImgText}
                            />
                        </Box>
                        <Box className={(isProcessing || oddStepOneStore.getImageText() === null || oddStepOneStore.getImageText() === '') ?
                            clsx(classes.disabled)
                            :
                            clsx(classes.disabled, classes.buttonStyle)

                        }>
                            <Button onClick={onClickCreateImgButton} disabled={isProcessing || oddStepOneStore.getImageText() === null || oddStepOneStore.getImageText() === ''} disableRipple>
                                <Typography>이미지 생성</Typography>
                            </Button>
                        </Box>
                    </Box>
                    <Box className={clsx(classes.rightTextBox, classes.imageBox)}>
                        <Box className={classes.iconButtonStyle}>
                            <IconButton disableRipple onClick={onClickCreateImgButton} disabled={isProcessing || oddStepOneStore.getImageText() === null || oddStepOneStore.getImageText() === ''}>
                                {(isProcessing || oddStepOneStore.getImageText() === null || oddStepOneStore.getImageText() === '') ?
                                    <RefreshDisableIcon />
                                    :
                                    <RefreshIcon/>
                                }
                            </IconButton>
                        </Box>
                        <Box className={classes.imageContent}>
                            {oddStepOneStore.getImage() === null ?
                                <img src={NoImage} alt='NoImage'/> :
                                <img src={'data:image/png;base64,' + oddStepOneStore.getImage()} alt='이미지'/>
                            }
                        </Box>
                        <Box className={!isProcessing ?
                            clsx(classes.disabled, classes.buttonStyle) :
                            clsx(classes.disabled)
                        }>
                            <Button onClick={onClickUploadButton} disabled={isProcessing} disableRipple>
                                <Typography>파일 업로드</Typography>
                            </Button>
                            <input type="file"
                                   ref={fileInput}
                                   accept="image/*"
                                   onChange={onChangeUploadButton}
                                   style={{display: "none"}}/>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}
export default withRouter(inject('contentStore','oddStepOneStore')(observer(OddStepOne)));
